import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgClose = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M20 5.35 18.65 4 12 10.66 5.35 4 4 5.35 10.66 12 4 18.65 5.35 20 12 13.34 18.65 20 20 18.65 13.34 12z"
}));
export default SvgClose;